import { render, staticRenderFns } from "./colegios.vue?vue&type=template&id=4d6b4fd6&scoped=true"
import script from "./colegios.vue?vue&type=script&lang=js"
export * from "./colegios.vue?vue&type=script&lang=js"
import style0 from "./colegios.vue?vue&type=style&index=0&id=4d6b4fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b4fd6",
  null
  
)

export default component.exports